import React, { ReactNode } from "react";

type AddProps = {
  onClick?(e: React.MouseEvent<HTMLElement>): void;
  icon?: ReactNode;
  className?: string;
  label?: string;
};

const AddButton = (props: AddProps) => {
  return (
    <div className={`add-button ${props.className ?? ""}`} onClick={props.onClick}>
      <div className="icon-container">{props.icon}</div>
      <div className="add-button-label">{props.label}</div>
    </div>
  );
};

export default AddButton;
